import fieldTypes from '../../../../../../enums/FieldTypes';
import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import postCode from '../../defaultFieldDefinitions/PostCode';
import streetName from '../../defaultFieldDefinitions/StreetName';
import * as max from '../../max-length-validators';
import PredictionsByField from '../../PredictionsByField';
import * as required from '../../required-validators';
import validateAutocompleteField from '../../validateAutocompleteField';

const cities = PredictionsByField.city('BH');

const FieldDefinitionBH = [
  addressee,
  postCode,
  companyName,
  nameNumber,
  streetName,
  addressLine2,
  {
    name: 'townCity',
    label: 'checkout.delivery.address.field.label.town.text',
    required: true,
    element: fieldTypes.AUTOCOMPLETE,
    placeholder: 'checkout.delivery.address.field.placeholder.townCity.autoComplete',
    predictions: cities,
    validate: [required.townCity, max.lengthAddress(35), validateAutocompleteField(cities, 'townCity')],
  },
  county,
];

export default FieldDefinitionBH;
